<div class="truck-registration-summary">
    <h1>{{'Sicherheitsbelehrung' | translate:
        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.title',
        translationService.language]}}</h1>

    <p *ngIf="isUsingSmartphone">{{'' | translate:
        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.description',
        translationService.language]}}</p>

    <mat-card>
        <table>
            <tr>
                <td class="label"><label>{{'' | translate:
                        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.numberPlate',
                        translationService.language]}}:</label></td>
                <td class="bold">{{numberPlate}}</td>
            </tr>
            <tr>
                <td class="label"><label>{{'' | translate:
                        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.driver',
                        translationService.language]}}:</label></td>
                <td class="bold">{{driver}}</td>
            </tr>
            <tr>
                <td class="label"><label>{{'' | translate:
                        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.label.carrier',
                        translationService.language]}}:</label></td>
                <td class="bold">{{carrier}}</td>
            </tr>
        </table>
    </mat-card>

    <div class="success">
        <sc-icon iconClass="fa-check-circle"></sc-icon>
    </div>

    <p class="gatekeeper-hint" *ngIf="gatekeeperMandatory">{{'gatekeeperMandatory' | translate:
        ['tmc-yard.widgets.registration-terminal.transport-registration-summary.hint', translationService.language]}}
    </p>
</div>